import { store } from "../store/index";
import moment from "moment";

/* Token functions */
function setToken(token) {
  let encryptString = "5de7jUzA7y0KQjERJG1F";
  token = `${encryptString}${token}`;
  store.commit("setToken", token);
  localStorage.setItem("xfiles_grpzi", token);
}

function getToken() {
  let token = store.state.token
    ? store.state.token
    : localStorage.getItem("xfiles_grpzi");

  if (token) {
    store.commit("setToken", token);
    return token.substr(20, token.length);
  }

  return false;
}

function removeToken() {
  store.commit("setToken", null);
  localStorage.removeItem("xfiles_grpzi");
  return localStorage.removeItem("renowedpzxip");
}

function formatAmount(amount) {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
  });

  return formatter.format(amount);
}

/* Miscellaneous functions*/
function subString(string, length) {
  return string.substring(0, length);
}

function stringifyArrayWithKey(myArray, key = "name") {
  let finalString = "";
  myArray.forEach((element, index) => {
    let name = element[key];
    let elementName = index == myArray.length - 1 ? name : `${name}, `;
    finalString += elementName;
  });

  return finalString;
}

function formatDate(dateTime) {
  return moment(dateTime).fromNow();
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/* User functions */
function isLoggedInUserAdmin() {
  if (!store.state.token) return false;
  if (store.state.isAdmin !== null) return store.state.isAdmin;

  let userData = localStorage.getItem("renowedpzxip");
  if (!userData) return false;
  storeUserData(JSON.parse(userData));

  return localStorage.getItem("user_type") == 0;
}

function storeUserData(userData) {
  localStorage.setItem("user_type", userData.role_id);
  localStorage.setItem("renowedpzxip", JSON.stringify(userData)); //user object
  store.commit("setIsAdmin", userData.role_id);
  store.commit("storeUserData", userData);
}

function getUserData() {
  let data = store.state.userData;
  if (data) return data;

  data = localStorage.getItem("renowedpzxip");
  if (!data) return false;
  data = JSON.parse(data);
  store.commit("storeUserData", data);
}

/* Project functions */

export {
  setToken,
  isLoggedInUserAdmin,
  getToken,
  subString,
  removeToken,
  formatDate,
  storeUserData,
  capitalizeFirstLetter,
  getUserData,
  stringifyArrayWithKey,
  formatAmount,
};
